import type { LocaleMessageBundle } from '../../types'
import { priceMessages as priceFeatureMessages } from './price'

export const priceMessages: LocaleMessageBundle = {
  vi: {
    ...priceFeatureMessages.vi,
  },
  en: {
    ...priceFeatureMessages.en,
  },
}
